// extracted by mini-css-extract-plugin
module.exports = {"aniFGsapB1":"aniFGsapB1_aniFGsapB1__DeeqI"};